"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./base");
var size_1 = require("./controller/size");
var interval_1 = require("./shape/interval");
var Interval = /** @class */ (function (_super) {
    tslib_1.__extends(Interval, _super);
    function Interval(cfg) {
        var _this = _super.call(this, tslib_1.__assign({ type: 'interval', shapeType: 'interval', generatePoints: true }, cfg)) || this;
        // 初始化 sizeController
        var sizeController = new size_1.default(_this);
        _this.set('sizeController', sizeController);
        // 设置 IntervalShapeFactory
        _this.set('shapeFactory', interval_1.default);
        return _this;
    }
    Interval.prototype.createShapePointsCfg = function (obj) {
        var cfg = _super.prototype.createShapePointsCfg.call(this, obj);
        cfg.size = this.getNormalizedSize(obj); // 获取每条数据对应的 size 归一化后的值
        return cfg;
    };
    Interval.prototype.isShareTooltip = function () {
        var isShareTooltip = this.get('shareTooltip');
        var coord = this.get('coord');
        var coordType = coord.type;
        if (coordType === 'theta' || (coordType === 'polar' && coord.isTransposed)) {
            isShareTooltip = false; // 饼图不合并
        }
        return isShareTooltip;
    };
    return Interval;
}(base_1.default));
exports.default = Interval;
//# sourceMappingURL=interval.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/interval.js
// module id = 809
// module chunks = 37